// extracted by mini-css-extract-plugin
module.exports = {"CompletedTitle":"Completed_CompletedTitle__2fAZN","YBYLLogoContainer":"Completed_YBYLLogoContainer__mGupw","CompletedCopy":"Completed_CompletedCopy__r4uNv"};